import { VIDEO_LUT_PRESETS } from './presets';
import type { LutPresetId, VideoEffects, VideoLut } from './types';

export type LutCard = {
  key: string;
  kind: 'original' | 'preset' | 'custom';
  presetId?: LutPresetId;
  labelKey: string;
  /** Literal label (the imported file name) shown instead of `labelKey`. */
  label?: string;
  /** What the thumbnail previews. Always full strength so looks compare fairly;
   *  the strength slider still sets the real amount. Original previews no LUT. */
  lut: VideoLut | null;
  selected: boolean;
};

/** Cards for the LUT carousel: Original first, then every preset, then the
 *  imported custom LUT when the clip has one. */
export function buildLutCards(value: VideoEffects): LutCard[] {
  const current = value.lut;
  const cards: LutCard[] = [
    { key: 'original', kind: 'original', labelKey: 'videoEffects.original', lut: null, selected: !current },
    ...VIDEO_LUT_PRESETS.map((preset): LutCard => ({
      key: `preset:${preset.id}`,
      kind: 'preset',
      presetId: preset.id,
      labelKey: preset.labelKey,
      lut: { preset: preset.id, strength: 1 },
      selected: current?.preset === preset.id,
    })),
  ];
  if (current?.preset === 'custom') {
    cards.push({
      key: 'custom',
      kind: 'custom',
      labelKey: 'videoEffects.customLut',
      label: current.name,
      lut: { ...current, strength: 1 },
      selected: true,
    });
  }
  return cards;
}
